export default "__VITE_ASSET__D8biR74___"